import styled from 'styled-components';

export const Button = styled.button`
  --bgcolor: black;
  --color: #fff;
  background: var(--bgcolor);
  color: var(--color);
  border: 0px solid transparent;
`;
